/* ==========================================================================
   PDP Info Tabs — desktop tab strip, mobile accordion (same markup, same
   click handler). Presentation switches by viewport via CSS only; the JS
   behavior is identical either way: exactly one panel open at a time,
   with the first panel open by default.
   ========================================================================== */
(function () {
  'use strict';

  function initTabs(root) {
    var tabs = root.querySelectorAll('.js-pdp-tab');
    var panels = root.querySelectorAll('.pdp-info-tabs__panel');

    function setPanel(panel, open) {
      panel.classList.toggle('is-active', open);
      panel.hidden = !open;
      var header = panel.querySelector('.pdp-info-tabs__accordion-header');
      if (header) header.setAttribute('aria-expanded', open);
      var navTab = root.querySelector('.pdp-info-tabs__tab[data-tab="' + panel.getAttribute('data-panel') + '"]');
      if (navTab) {
        navTab.classList.toggle('is-active', open);
        navTab.setAttribute('aria-selected', open);
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab');
        var targetPanel = root.querySelector('.pdp-info-tabs__panel[data-panel="' + target + '"]');

        panels.forEach(function (panel) {
          setPanel(panel, panel === targetPanel);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.pdp-info-tabs').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
